/**
 * Cloud Functions (HTTP onRequest) のURLを環境に応じて組み立てる。
 *
 * - 開発/本番の切り替えは `VITE_FIREBASE_PROJECT_ID` で自動的に行う
 * - 例外的に別ドメインを使いたい場合は `VITE_FUNCTIONS_BASE_URL` で上書き可能
 */
export function getFunctionsBaseUrl(region = 'asia-northeast1'): string {
  const override = (import.meta.env.VITE_FUNCTIONS_BASE_URL as string | undefined)?.trim();
  if (override) {
    return override.replace(/\/+$/, '');
  }

  const projectId = (import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined)?.trim();
  if (!projectId) {
    // ここが空だと、どのみちFirebase初期化も壊れるので早めに気付けるようにする
    throw new Error('VITE_FIREBASE_PROJECT_ID が未設定です');
  }

  return `https://${region}-${projectId}.cloudfunctions.net`;
}

export function buildFunctionUrl(functionName: string, region = 'asia-northeast1'): string {
  const base = getFunctionsBaseUrl(region);
  const name = functionName.replace(/^\/+/, '');
  return `${base}/${name}`;
}

